module.exports = __webpack_public_path__ + "media/assets/faria_products/IB Primary Years-bf660b200c8d6b08be12b4502ee7d69ae1a185c5777c03e558b76f6f61d877e1.png";